import { createStyles } from "@mantine/core";

const EmployeeStatusBadgeStyles = createStyles(() => ({
  label: {
    padding: "6px 12px 5px",
    borderRadius: "32px",
    fontSize: "11px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1,
    letterSpacing: "0.16px",
    textAlign: "left",
    color: "#495057",
  },
  active: {
    backgroundColor: "rgba(32, 201, 151, 0.3)",
  },
}));

export default EmployeeStatusBadgeStyles;
